export default {
  SET: 'setHighlitedEvent',
};
